import classNames from "classnames";
import { FC, ReactNode } from "react";

const Tag: FC<{
  title: ReactNode;
  subtitle?: ReactNode;
  icon: ReactNode;
  className?: string;
}> = ({
  title,
  subtitle,
  icon,
  className,
}) => {
  return (
    <div
      className={classNames("bg-background-default font-manrope flex w-full items-center gap-2 rounded-md px-6 py-4 shadow-sm whitespace-nowrap flex-nowrap w-min", className)}
    >
      <div className="aspect-square h-10">{icon}</div>
      <div className="flex flex-col items-start leading-6">
        <div className="text-base font-semibold">{title}</div>
        <div className="text-font-subtle text-xs font-medium">{subtitle}</div>
      </div>
    </div>
  );
};

export default Tag;
